if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.sym-slides').slick();

    // custom script booking
    if (window.location.pathname != '/in-room-guide/') {
        if (document.querySelector('#stay-wanderful')) {   
            document.querySelector('#stay-wanderful').setAttribute('style', 'display: none');
        }
    }

    if (document.querySelector('#popInSpecial')) {   
        document.querySelector('#popinClose').addEventListener('click', function(e){
            document.querySelector('#popInSpecial').classList.toggle('active');
        });
    }
    let elementInformation = document.querySelector('#popInSpecial .popin__special-text.slide > p')   
    if (elementInformation) {
        elementInformation.addEventListener('click', function(e){
            document.querySelector('.popin__special-text.slide').classList.toggle('hidden');
            document.querySelector('.popin__special-text.secondary').classList.toggle('hidden');
        })
    }
    let comeBackPopIn = document.querySelector('.popin__special-back')
    if (comeBackPopIn) {
        comeBackPopIn.addEventListener('click', function(e){
            document.querySelector('.popin__special-text.slide').classList.toggle('hidden');
            document.querySelector('.popin__special-text.secondary').classList.toggle('hidden');
        })
    }

    document.querySelector('#book-direct').addEventListener('click', function(e){
        document.querySelector('#book-direct').classList.toggle('hidden');
        document.querySelector('#popInSpecial').classList.toggle('hidden');
    })
    document.querySelector('#popinClose').addEventListener('click', function(e){
        document.querySelector('#book-direct').classList.toggle('hidden');
        document.querySelector('#popInSpecial').classList.toggle('hidden');
    })
    if (window.screen.width > 768) {
        $('#popInSpecial .popin__special-text.slide .sym-inline-list').slick({
            accessibility: false,
            fade: true,
            infinite: true,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
        });
    }
        
    document.querySelector('#popInSpecial').classList.add('hidden');
    document.querySelector('.popin__special-text.secondary').classList.add('hidden');
    
    
})();



